import i18n from '../lang/index'
import $i18 from '@/utils/I18.js'
export default {
  //采购商进出口分析表头
  companyTradeSupDetail: [
    {
      title: i18n.t('tableHeader.departure'),
      key: 'port',
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    // {
    //   title: i18n.t('countryorRegion'),
    //   key: 'country',
    //   align: 'center',
    //   headerAlign: 'center',
    //   width:100
    // },
    {
      title: i18n.t('tableHeader.tradeNumS'),
      key: 'tradeCount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    }, {
      title: i18n.t('amount'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.mun'),
      key: 'quantity',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.weight'),
      key: 'weight',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.boxNum'),
      key: 'boxCount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    }
  ],
  totalHeader: [
    {
      title: "",
      key: 'allData',
      align: 'left',
      headerAlign: 'left'
      ,
      width: 98
    },
    {
      title: i18n.t('tableHeader.tradeNumS'),
      key: 'count',
      align: 'right',
      headerAlign: 'count',
      width: 200
    },
    {
      title: i18n.t('amount'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right'
      ,
      width: 200
    },
    {
      title: i18n.t('tableHeader.mun'),
      key: 'quantity',
      align: 'right',
      headerAlign: 'right'
      ,
      width: 200
    },
    {
      title: i18n.t('tableHeader.weight'),
      key: 'weight',
      align: 'right',
      headerAlign: 'right'
      ,
      width: 200
    },
    {
      title: i18n.t('tableHeader.boxNum'),
      key: 'boxCount',
      align: 'right',
      headerAlign: 'right'
      ,
      width: 200
    }
  ],

  totalDetail: [
    {
      title: i18n.t('supplier'),
      key: 'supplier',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
      // type: 'name'
    },
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'center',
      headerAlign: 'center',
      isShowFilter: true,
      input: "select",
      width: 100
    },
    {
      title: i18n.t('tableHeader.tradeNumS'),
      key: 'count',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('amount'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.mun'),
      key: 'quantity',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.weight'),
      key: 'weight',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.boxNums'),
      key: 'boxCount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    }
  ],
  //供应商分布详细数据表头
  totalDetailSpread: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'center',
      headerAlign: 'center',
      width: 100
    },
    {
      title: i18n.t('tableHeader.numberOfSuppliers'),
      key: 'supplierCount',
      align: 'right',
      headerAlign: 'right',
      width: 100
    },
    {
      title: i18n.t('tableHeader.tradeNumS'),
      key: 'count',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('amount'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.mun'),
      key: 'quantity',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.weight'),
      key: 'weight',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.boxNums'),
      key: 'boxCount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    }
  ],
  //采购商分布详细数据表头
  totalDetailBuyerSpread: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'center',
      headerAlign: 'center',
      width: 100
    },
    {
      title: i18n.t('tableHeader.numberOfBuyers'),
      key: 'buyerCount',
      align: 'right',
      headerAlign: 'right',
      width: 100
    },
    {
      title: i18n.t('tableHeader.tradeNumS'),
      key: 'count',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('amount'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.mun'),
      key: 'quantity',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.weight'),
      key: 'weight',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    },
    {
      title: i18n.t('tableHeader.boxNums'),
      key: 'boxCount',
      align: 'right',
      headerAlign: 'right',
      sort: 'custom',
      width: 100
    }
  ],
  statisticaData: [
    {
      title: i18n.t('tableHeader.tradeMonth'),
      key: 'month',
      align: 'right',
      headerAlign: 'right',
      width: 100
    },
    {
      title: i18n.t('tableHeader.tradeNumS'),
      key: 'count',
      align: 'right',
      headerAlign: 'right',
      width: 200
    },
    {
      title: i18n.t('amount'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right'
      ,
      width: 200
    },
    {
      title: i18n.t('tableHeader.mun'),
      key: 'quantity',
      align: 'right',
      headerAlign: 'right'
      ,
      width: 200
    },
    {
      title: i18n.t('tableHeader.weight'),
      key: 'weight',
      align: 'right',
      headerAlign: 'right'
      ,
      width: 200
    },
    {
      title: i18n.t('tableHeader.boxNum'),
      key: 'boxCount',
      align: 'right',
      headerAlign: 'right'
      ,
      width: 200
    },
  ],
  searchBusinessColumns: [
    {
      title: i18n.t('tableHeader.listName'),
      key: 'name',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.enterprisesNum'),
      key: 'count',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      width: 120,
      items: [
        {
          name: i18n.t('edit'),
          key: 'edit',
          icon: 'edit'
        },
        {
          name: i18n.t('look'),
          key: 'search',
          icon: 'search'
        },
        {
          name: i18n.t('delete'),
          key: 'delete',
          icon: 'delete'
        }
      ]
    }
  ],
  searchSmartBusiness: [
    {
      title: i18n.t('tableHeader.listName'),
      key: 'name',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.enterprisesNum'),
      key: 'companyCount',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      width: 120,
      items: [
        // {
        //   name: i18n.t('edit'),
        //   key: 'edit',
        //   icon: 'edit'
        // },
        {
          name: i18n.t('look'),
          key: 'search',
          icon: 'search'
        },
        {
          name: i18n.t('delete'),
          key: 'delete',
          icon: 'delete'
        }
      ]
    }
  ],
  productTag: [
    {
      title: i18n.t('tableHeader.labelName'),
      key: 'name',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.market'),
      key: 'country',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      width: 120,
      items: [
        // {
        //   name: i18n.t('edit'),
        //   key: 'edit',
        //   icon: 'edit'
        // },
        {
          name: i18n.t('look'),
          key: 'search',
          icon: 'search'
        },
        {
          name: i18n.t('delete'),
          key: 'delete',
          icon: 'delete'
        }
      ]
    }
  ],
  historySearch: [
    {
      title: i18n.t('trendAnalysis.dataTime'),
      key: 'date',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('tableHeader.searchContent'),
      key: 'keyword',
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      items: [
        {
          name: i18n.t('tableHeader.searchAgain'),
          key: 'search',
          icon: 'search'
        },
        {
          name: i18n.t('delete'),
          key: 'delete',
          icon: 'delete'
        }
      ]
    }
  ],
  trendArea: [
    {
      title: i18n.t('countryorRegion'),
      key: 'title',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.IncreaseAmount'),
      key: 'val',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('tableHeader.growthRatio'),
      key: 'ratio',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  trendAreaGrouth: [
    {
      title: i18n.t('countryorRegion'),
      key: 'title',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: $i18.language('增长值'),
      key: 'val',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('tableHeader.growthRatio'),
      key: 'ratio',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  companyTradeDetail: [
    {
      title: i18n.t('tableHeader.dataSource'),
      key: 'dataSource',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.sourceType'),
      key: 'ie',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('tableHeader.tradeRole'),
      key: 'tradeRole',
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      title: i18n.t('tableHeader.tradePercentage'),
      key: 'tradeCount',
      align: 'center',
      headerAlign: 'center',
      sortable: true
    },
    {
      title: i18n.t('tableHeader.amount'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  companyContacts: [
    {
      title: i18n.t('tableHeader.contacts'),
      key: 'name',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.sourceMode'),
      key: 'typeName',
      align: 'center',
      headerAlign: 'center'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.position'),
      key: 'job',
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: i18n.t('email'),
      key: 'email',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('phone'),
      key: 'tel',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('tableHeader.fax'),
      key: 'fax',
      align: 'center',
      headerAlign: 'center'
    }
  ],
  // 海关企业联系人
  customsCompanyContacts: [
    {
      title: i18n.t('tableHeader.contacts'),
      key: 'name',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.sourceMode'),
      key: 'typeName',
      align: 'center',
      headerAlign: 'center'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.position'),
      key: 'job',
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: i18n.t('email'),
      key: 'email',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('phone'),
      key: 'tel',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('tableHeader.fax'),
      key: 'fax',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('media'),
      key: 'links',
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    }
  ],
  nedatany: [
    {
      title: '',
      key: 'year',
      align: 'left',
    },
    {
      title: i18n.t('tableHeader.January'),
      key: 'month1',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.February'),
      key: 'month2',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.March'),
      key: 'month3',
      align: 'left',
    },
    {
      title: i18n.t('tableHeader.April'),
      key: 'month4',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.May'),
      key: 'month5',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.June'),
      key: 'month6',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.July'),
      key: 'month7',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.August'),
      key: 'month8',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.September'),
      key: 'month9',
      align: 'left',

    }, {
      title: i18n.t('tableHeader.October'),
      key: 'month10',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.November'),
      key: 'month11',
      align: 'left',

    }, {
      title: i18n.t('tableHeader.December'),
      key: 'month12',
      align: 'left',

    },
    {
      title: i18n.t('tableHeader.yearTotal'),
      key: 'yearTotal',
      align: 'left',
    },

  ],
  companySupplierDetail: [
    {
      title: i18n.t('supplier'),
      key: 'supplier',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
      // type: 'name'
    },
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'center',
      headerAlign: 'center',
      isShowFilter: true,
      input: "select",
    },
    {
      title: i18n.t('tableHeader.tradeNumT'),
      key: 'val',
      align: 'right',
      sort: 'custom',
      headerAlign: 'right',
    },
    {
      title: $i18.language('占比'),
      key: 'ratio',
      width: 60,
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: $i18.language('最新相关交易'),
      key: 'lastTradeDate',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  companySupplierAreaDetail: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: i18n.t('tableHeader.numberOfSuppliers'),
      key: 'supplierCount',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('tableHeader.tradeNumT'),
      key: 'val',
      sort: 'custom',
      align: 'right',
      headerAlign: 'right',
    },
    // {
    //   title: i18n.t('tableHeader.tradeNum'),
    //   key: 'tradeCount',
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      title: i18n.t('tableHeader.amountNum'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  companyBuyerDetail: [
    {
      title: i18n.t('purchaser'),
      key: 'buyer',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
      // type: 'name'
    },
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'center',
      isShowFilter: true,
      input: "select",
      headerAlign: 'center'
    },
    {
      title: i18n.t('tableHeader.tradeNumT'),
      key: 'val',
      align: 'right',
      sort: 'custom',
      headerAlign: 'right',
    },
    {
      title: $i18.language('占比'),
      key: 'ratio',
      width: 60,
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: $i18.language('最新相关交易'),
      key: 'lastTradeDate',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  companyBuyerAreaDetail: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: i18n.t('tableHeader.buyNum'),
      key: 'buyerCount',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('tableHeader.tradeNumT'),
      key: 'val',
      sort: 'custom',
      align: 'right',
      headerAlign: 'right',
    },
    // {
    //   title: i18n.t('tableHeader.tradeNum'),
    //   key: 'tradeCount',
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      title: i18n.t('tableHeader.amountNum'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  mainSupplierList: [
    {
      title: i18n.t('supplier'),
      key: 'supplier',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('tableHeader.tradeNumT'),
      key: 'tradeCount',
      align: 'right',
      headerAlign: 'right',
    }
  ],
  mainProductsList: [
    {
      title: i18n.t('keyWord'),
      key: 'productKeyword',
      align: 'left',
      headerAlign: 'left',
      width: 170
    },
    {
      title: i18n.t('tableHeader.tradeLine'),
      key: 'tradeRoutes',
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: i18n.t('tableHeader.tradeNum'),
      key: 'val',
      align: 'right',
      headerAlign: 'right',
    },
    {
      title: $i18.language('占比'),
      key: 'ratio',
      align: 'right',
      headerAlign: 'right',
      width: 70
    }
  ],
  companyProductKeywordDetail: [
    {
      title: i18n.t('keyWord'),
      key: 'productKeyword',
      isShowFilter: true,
      input: "inputText",
      align: 'left',
      headerAlign: 'left',
      width: 170
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.tradeLine'),
      key: 'tradeRoutes',
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: i18n.t('tableHeader.tradeNum'),
      key: 'val',
      align: 'right',
      headerAlign: 'right',
    },
    {
      title: $i18.language('占比'),
      key: 'ratio',
      align: 'right',
      headerAlign: 'right',
      width: 70
    },
    {
      title: i18n.t('tableHeader.tradTrend'),
      key: 'trend',
      align: 'center',
      headerAlign: 'center',
      notTooltip: true,
      type: 'customerlized'
    }
  ],
  companyProductHsCodeDetail: [
    {
      title: i18n.t('hsCode'),
      key: 'hsCode',
      align: 'left',
      headerAlign: 'left',
      isShowFilter: true,
      input: "multTagText",
    },
    {
      key: 'hsCodeDescription',
      title: i18n.t('tableHeader.codeDes'),
      align: 'left',
      headerAlign: 'left',
      width: 170
    },
    {
      title: i18n.t('tableHeader.tradeNumT'),
      key: 'val',
      align: 'center',
      headerAlign: 'center',
    },
    {
      title: i18n.t('tableHeader.tradTrend'),
      key: 'trend',
      align: 'center',
      headerAlign: 'center',
      notTooltip: true,
      type: 'customerlized'
    }
  ],
  trendIndustryArea: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      title: i18n.t('trendAnalysis.china.total'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('tableHeader.proportion'),
      key: 'ratio',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  trendIndustryMarket: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      title: i18n.t('trendAnalysis.china.increase'),
      key: 'increaseAmount',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('trendAnalysis.china.splyGrowth'),
      key: 'increaseRatio',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  trendIndustryMarketOut: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      title: i18n.t('trendAnalysis.china.increase'),
      key: 'increaseAmount',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title:  i18n.t('trendAnalysis.china.splyGrowth'),
      key: 'increaseRatio',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  avgPriceTable: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      sortable: false,
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: $i18.language('数据时段均量'),
      key: 'price',
      sortable: false,
      align: 'right',
      headerAlign: 'right'
    }
  ],
  analysisITradeType: [
    {
      title: i18n.t('tableHeader.month'),
      key: 'month',
      sortable: false,
    },
    {
      title: i18n.t('amount'),
      key: 'amount',
      sortable: false,
    },
    {
      title: i18n.t('trendAnalysis.china.splyGrowth'),
      key: 'rate',
      sortable: false,
    }
  ],
  exclusivetable: [
    {
      title: i18n.t('tableHeader.timeSlot'),
      key: 'dt',
      sortable: true,
      align: 'left',
    },
    {
      title: i18n.t('hsCode'),
      key: 'hscode4',
      sortable: false,
      align: 'left',
      headerAlign:'left'
    },
    {
      title: i18n.t('tableHeader.tradePerson'),
      key: 'ctryid_country_name',
      // sortable: true,
      align: 'left',
      headerAlign:'left',
      // width: 180,
      isShowSort:true,//是否需要排序组件
      // isShowFilter:true,//是否需要过滤组件
      input:'text',
      options:[]
    },
    {
      title: $i18.language("收发货地"),
      key: 'city',
      // sortable: true,
      align: 'left',
      // width: 180,
      headerAlign:'left',
      isShowSort:true,//是否需要排序组件
      // isShowFilter:true,//是否需要过滤组件
      input:'text',
      options:[]
    },
    {
      title: i18n.t('tableHeader.amountNum'),
      key: 'val',
      sortable: true,
      align: 'right'
    },
    {
      title: i18n.t('tableHeader.numOne'),
      key: 'quantity_1',
      sortable: true,
      align: 'right'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.numOneUnit'),
      key: 'quantity_1_unit',
      sortable: false,
      align: 'right'
    },
    {
      title: i18n.t('tableHeader.numOneUnitPrice'),
      key: 'price_usd_1',
      sortable: true,
      align: 'right'

    },
    {
      title: i18n.t('tableHeader.numTwo'),
      key: 'quantity_2',
      sortable: true,
      align: 'right'
    },
    {
      title: i18n.t('tableHeader.numTwoUnit'),
      key: 'quantity_2_unit',
      sortable: false,
      align: 'right'
    },
    {
      title: i18n.t('tableHeader.numTwoUnitPrice'),
      key: 'price_usd_2',
      sortable: true,
      align: 'right'
    }
  ],
  trendBalanced: [
    {
      title: i18n.t('countryorRegion'),
      key: 'country',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('tableHeader.absolutData'),
      key: 'differenceAmount',
      align: 'left',
      headerAlign: 'left'
    },
    {
      title: i18n.t('tableHeader.differenceType'),
      key: 'differenceType',
      align: 'center',
      headerAlign: 'center'
    }
  ],
  tradeTypes: [
    {
      title: i18n.t('tableHeader.month'),
      key: 'month',
      align: 'left',
      headerAlign: 'left'
      // type: 'name'
    },
    {
      title: i18n.t('trendAnalysis.china.total'),
      key: 'amount',
      align: 'right',
      headerAlign: 'right'
    },
    {
      title: i18n.t('tableHeader.rate'),
      key: 'rate',
      align: 'right',
      headerAlign: 'right'
    }
  ],
  companyTradeSupplierPortDetail: [
    {
      title: i18n.t('tableHeader.departure'),
      key: 'port',
      align: 'left',
      headerAlign: 'left'
    },
    // {
    //   title: i18n.t('countryorRegion'),
    //   key: 'country',
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      title: i18n.t('tableHeader.trade'),
      key: 'tradeCount',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('tableHeader.boxNumT'),
      key: 'boxCount',
      align: 'center',
      headerAlign: 'center'
    }
    // {
    //   title: '差额类型',
    //   key: 'differenceType',
    //   align: 'left',
    //   headerAlign: 'left'
    // }
  ],
  companyTradeBuyerPortDetail: [
    {
      title: i18n.t('tableHeader.departure'),
      key: 'port',
      align: 'left',
      headerAlign: 'left'
    },
    // {
    //   title: i18n.t('countryorRegion'),
    //   key: 'country',
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      title: i18n.t('tableHeader.trade'),
      key: 'tradeCount',
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('tableHeader.boxNumT'),
      key: 'boxCount',
      align: 'center',
      headerAlign: 'center'
    }
    // {
    //   title: '差额类型',
    //   key: 'differenceType',
    //   align: 'left',
    //   headerAlign: 'left'
    // }
  ],
  mergeCompany: [
    {
      title: i18n.t('tableHeader.enterpriseName'),
      key: 'companyName',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      title: i18n.t('operation'),
      key: 'operate',
      type: 'customerlized'
    }
    // {
    //   title: i18n.t('operation'),
    //   key: 'opration',
    //   items: [
    //     {
    //       name: '主企业',
    //       key: 'edit',
    //       icon: 'edit'
    //     },
    //     {
    //       name: i18n.t('delete'),
    //       key: 'delete',
    //       icon: 'delete'
    //     }
    //   ]
    // }
  ],
  companyMergeCompany: [
    // 企业ID
    {
      title: i18n.t('tableHeader.enterpriseId'),
      key: 'oldId',
      align: 'center',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      notTooltip: true
    },
    // 公司名称
    {
      title: i18n.t('tableHeader.enterpriseName'),
      key: 'companyName',
      type: 'customerlized',
      align: 'left',
      headerAlign: 'left',
      width: 260
    },
    // 企业所在国
    {
      title: i18n.t('tableHeader.enterpriseCountry'),
      key: 'country',
      align: 'center',
      align: 'left',
      headerAlign: 'left',
    },
    // 合并方
    // {
    //   title: i18n.t('tableHeader.enterpriseMerge'),
    //   key: 'companyName1',
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      title: i18n.t('operation'),
      key: 'operate',
      type: 'customerlized',
      width: localStorage.getItem("language")=='en'?'200':'128',
      notTooltip: true
    }
  ],
  // 未解决合并企业缓存数据问题
  companySimilarMergeCompany: [
    // 企业ID
    {
      title: i18n.t('tableHeader.enterpriseId'),
      key: 'oldId',
      align: 'center',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      notTooltip: true
    },
    // 公司名称
    {
      title: i18n.t('tableHeader.enterpriseName'),
      key: 'companyName',
      type: 'customerlized',
      align: 'left',
      headerAlign: 'left',
      width: 260
    },
    // 企业所在国
    {
      title: i18n.t('tableHeader.enterpriseCountry'),
      key: 'country',
      align: 'center',
      align: 'left',
      headerAlign: 'left',
      isShowFilter: true
    },
    // 合并方
    // {
    //   title: i18n.t('tableHeader.enterpriseMerge'),
    //   key: 'companyName1',
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      title: i18n.t('operation'),
      key: 'operate',
      type: 'customerlized',
      width: localStorage.getItem("language")=='en'?'200':'128',
      notTooltip: true
    }
  ],
  companyShareMergeCompany: [
    // 企业ID
    {
      title: i18n.t('tableHeader.enterpriseId'),
      key: 'oldId',
      align: 'center',
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      notTooltip: true
    },
    // 公司名称
    {
      title: i18n.t('tableHeader.enterpriseName'),
      key: 'companyName',
      type: 'customerlized',
      align: 'left',
      headerAlign: 'left',
      width: 260
    },
    // 企业所在国
    {
      title: i18n.t('tableHeader.enterpriseCountry'),
      key: 'country',
      align: 'center',
      align: 'left',
      headerAlign: 'left',
    },
  ],
  tradeMarket: [
    {
      key: 'month',
      title: i18n.t('tableHeader.tradeMonth'),
      align: 'left',
      headerAlign: 'left'
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    }
    // {
    //   key: 'ratio',
    //   title:i18n.t('tableHeader.proportion'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized' //代表列的内容是自定义的
    // }
  ],
  tradeCountry: [
    {
      key: 'country',
      title: i18n.t('tableHeader.countryName'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    }
    // {
    //   key: 'ratio',
    //   title:i18n.t('tableHeader.proportion'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized' //代表列的内容是自定义的
    // }
  ],
  tradeNewBuyer: [
    {
      key: 'name',
      title: i18n.t('tableHeader.purchaserName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 350,
      notTooltip: true,
      customerHeader: true
    },
    {
      key: 'country',
      title: i18n.t('countryorRegion'),
      align: 'right',
      headerAlign: 'right',
      trigger: 'click',
      type: 'normal'
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    }
    // {
    //   key: 'ratio',
    //   title:i18n.t('tableHeader.proportion'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized' //代表列的内容是自定义的
    // }
  ],
  tradeNewSupplier: [
    {
      key: 'name',
      title: i18n.t('tableHeader.supplierName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 350,
      notTooltip: true,
      customerHeader: true
    },
    {
      key: 'country',
      title: i18n.t('countryorRegion'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal',
      trigger: 'click',
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    }
    // {
    //   key: 'ratio',
    //   title:i18n.t('tableHeader.proportion'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized' //代表列的内容是自定义的
    // }
  ],
  tradeBuyer: [
    {
      key: 'name',
      title: i18n.t('tableHeader.purchaserName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 350,
      notTooltip: true,
      customerHeader: true
    },
    {
      key: 'country',
      title: i18n.t('countryorRegion'),
      align: 'right',
      headerAlign: 'right',
      isShowFilter: true,
      trigger: 'click',
      type: 'normal'
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    }
    // {
    //   key: 'ratio',
    //   title:i18n.t('tableHeader.proportion'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized' //代表列的内容是自定义的
    // }
  ],
  tradeSupplier: [
    {
      key: 'name',
      title: i18n.t('tableHeader.supplierName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 350,
      notTooltip: true,
      customerHeader: true
    },
    {
      key: 'country',
      title: i18n.t('countryorRegion'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal',
      isShowFilter: true,
      trigger: 'click',
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    }
    // {
    //   key: 'ratio',
    //   title:i18n.t('tableHeader.proportion'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized' //代表列的内容是自定义的
    // }
  ],
  tradeBrand: [
    {
      key: 'name',
      title: i18n.t('tableHeader.brandName'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    }
    // {
    //   key: 'ratio',
    //   title:i18n.t('tableHeader.proportion'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized' //代表列的内容是自定义的
    // }
  ],
  tradeAveragePrice: [
    {
      key: 'month',
      title: i18n.t('tableHeader.tradeMonth'),
      align: 'left',
      headerAlign: 'left'

    },
    {
      key: 'quantityAveragePrice',
      title: i18n.t('tableHeader.munE'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'weightAveragePrice',
      title: i18n.t('tableHeader.weightE'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    },
    {
      key: 'boxAveragePrice',
      title: i18n.t('tableHeader.boxNumE'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
      // sort: true
    }
    // {
    //   key: 'ratio',
    //   title:i18n.t('tableHeader.proportion'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized' //代表列的内容是自定义的
    // }
  ],
  tradeBuyer1: [
    {
      key: 'name',
      title: i18n.t('tableHeader.purchaserName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.tradeAllNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  tradeBuyer2: [
    {
      key: 'name',
      title: i18n.t('tableHeader.purchaserName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.allAcount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  tradeBuyer3: [
    {
      key: 'name',
      title: i18n.t('tableHeader.purchaserName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.totalNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  tradeBuyer4: [
    {
      key: 'name',
      title: i18n.t('tableHeader.purchaserName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.totalWeight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  tradeSupplier1: [
    {
      key: 'name',
      title: i18n.t('tableHeader.supplierName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.tradeAllNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  tradeSupplier2: [
    {
      key: 'name',
      title: i18n.t('tableHeader.supplierName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.allAcount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  tradeSupplier3: [
    {
      key: 'name',
      title: i18n.t('tableHeader.supplierName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.totalNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  tradeSupplier4: [
    {
      key: 'name',
      title: i18n.t('tableHeader.supplierName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 200
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.totalWeight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  tradePortf1: [
    {
      key: 'port',
      title: i18n.t('tableHeader.departure'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    //   key: 'country',
    //   title: i18n.t('countryorRegion'),
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'center',
      headerAlign: 'center'
    },
  ],
  tradePortf2: [
    {
      key: 'port',
      title: i18n.t('tableHeader.departure'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    //   key: 'country',
    //   title: i18n.t('countryorRegion'),
    //   align: 'center',
    //   headerAlign: 'center'
    // },

    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'center',
      headerAlign: 'center'
    },
  ],
  tradePortf3: [
    {
      key: 'port',
      title: i18n.t('tableHeader.departure'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    //   key: 'country',
    //   title: i18n.t('countryorRegion'),
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'center',
      headerAlign: 'center'
    },

  ],
  tradePortf4: [
    {
      key: 'port',
      title: i18n.t('tableHeader.departure'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    //   key: 'country',
    //   title: i18n.t('countryorRegion'),
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'center',
      headerAlign: 'center'
    },

  ],
  // 123
  tradePort1: [
    {
      key: 'port',
      title: i18n.t('tableHeader.departure'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    //   key: 'country',
    //   title: i18n.t('countryorRegion'),
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right'
    },
    // {
    //   key: 'value',
    //   title: i18n.t('tableHeader.tradeAllNum'),
    //   align: 'right',
    //   headerAlign: 'right',
    //   type: 'normal'
    // },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNumT'),
      align: 'right',
      headerAlign: 'right'
    }
  ],
  tradeHsCode: [
    {
      key: 'name',
      title: i18n.t('hsCode'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right'
    },
    // {
    //   key: 'value',
    //   title: i18n.t('tableHeader.tradeAllNum'),
    //   align: 'right',
    //   headerAlign: 'right',
    //   type: 'normal'
    // },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNumT'),
      align: 'right',
      headerAlign: 'right'
    }
  ],
  tradePort2: [
    {
      key: 'port',
      title: i18n.t('tableHeader.destination'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    // {
    //   key: 'country',
    //   title: i18n.t('countryorRegion'),
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumS'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeAmount',
      title: i18n.t('amount'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeQuantity',
      title: i18n.t('tableHeader.mun'),
      align: 'right',
      headerAlign: 'right'
    },
    {
      key: 'tradeWeight',
      title: i18n.t('tableHeader.weight'),
      align: 'right',
      headerAlign: 'right'
    },
    // {
    //   key: 'value',
    //   title: i18n.t('tableHeader.allAcount'),
    //   align: 'right',
    //   headerAlign: 'right',
    //   type: 'normal'
    // },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNumT'),
      align: 'right',
      headerAlign: 'right'
    }
  ],
  tradePort3: [
    {
      key: 'port',
      title: '',
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    // {
    //   key: 'country',
    //   title: i18n.t('countryorRegion'),
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      key: 'value',
      title: i18n.t('tableHeader.totalNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNumT'),
      align: 'center',
      headerAlign: 'center'
    }
  ],
  tradePort4: [
    {
      key: 'port',
      title: '',
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    // {
    //   key: 'country',
    //   title: i18n.t('countryorRegion'),
    //   align: 'center',
    //   headerAlign: 'center'
    // },
    {
      key: 'value',
      title: i18n.t('tableHeader.totalWeight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'boxCount',
      title: i18n.t('tableHeader.boxNumT'),
      align: 'center',
      headerAlign: 'center'
    }
  ],
  productExp1: [
    {
      key: 'country',
      title: i18n.t('countryorRegion'),
      align: 'left',
      headerAlign: 'left'
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.tradeAllNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  productExp2: [
    {
      key: 'country',
      title: i18n.t('countryorRegion'),
      align: 'left',
      headerAlign: 'left'
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.allAcount'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  productExp3: [
    {
      key: 'country',
      title: i18n.t('countryorRegion'),
      align: 'left',
      headerAlign: 'left'
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.totalNum'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  productExp4: [
    {
      key: 'country',
      title: i18n.t('countryorRegion'),
      align: 'left',
      headerAlign: 'left'
    },
    {
      key: 'value',
      title: i18n.t('tableHeader.totalWeight'),
      align: 'right',
      headerAlign: 'right',
      type: 'normal'
    },
    {
      key: 'ratio',
      title: i18n.t('tableHeader.proportion'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized' // 代表列的内容是自定义的
    }
  ],
  companyHsCodeDetail: [
    {
      key: 'rankNo',
      title: i18n.t('tableHeader.ranking'),
      align: 'center',
      headerAlign: 'center',
      width: 50
    },
    {
      key: 'hsCode',
      title: i18n.t('hsCode'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'description',
      title: i18n.t('tableHeader.HSdescription'),
      align: 'left',
      headerAlign: 'left',
      width: 200
    },
    {
      key: 'count',
      title: i18n.t('tableHeader.times'),
      align: 'center',
      headerAlign: 'center'
    }
  ],
  companyDeleteCloumn: [
    {
      key: 'value',
      title: i18n.t('keyWord'),
      align: 'center',
      headerAlign: 'center',
      // width: 50
    },
    {
      key: 'time',
      title: $i18.language('删除时间'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('operation'),
      key: 'operate',
      type: 'customerlized'
      // title: i18n.t('operation'),
      // key: 'opration',
      // items: [
      //   {
      //     name: '恢复',
      //     key: 'detail',
      //     icon: 'detail'
      //   },
      // ]
      // width: 120,  
    }
  ],
  ChildCollectCompany: [
    {
      key: 'childAccount',
      title: i18n.t('tableHeader.subAccount'),
      headerAlign: 'center',
      align: 'center',
      width: 120
    },
    {
      key: 'companyName',
      title: i18n.t('tableHeader.enterpriseName'),
      align: 'left',
      headerAlign: 'left',
      width: 150,
      type: 'customerlized'
    },
    {
      key: 'collectTime',
      title: i18n.t('tableHeader.focusTime'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'subscribe',
      title: i18n.t('tableHeader.subscription'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    // {
    //   key: 'isPersonal',
    //   title: i18n.t('tableHeader.exclusive'),
    //   align: 'center',
    //   headerAlign: 'center',
    //   type: 'customerlized'
    // },
    {
      key: 'isExclusive',
      title: i18n.t('tableHeader.exclusive'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      title: i18n.t('operation'),
      key: 'hide-opration',
      items: [
        {
          name: i18n.t('tableHeader.viewDetails'),
          key: 'detail',
          icon: 'detail'
        },
        {
          name: i18n.t('tableHeader.cancelView'),
          key: 'cancel-collect',
          icon: 'cancel-collect'
        }
      ]
    }
  ],
  dashboardCollectCompany: [
    {
      key: 'companyName',
      title: i18n.t('tableHeader.enterpriseName'),
      align: 'left',
      headerAlign: 'left',
      width: 180,
      type: 'customerlized'
    },
    {
      key: 'lastTradeDate',
      title: i18n.t('tableHeader.newTradetime'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumT'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      key: 'partnerCount',
      title: i18n.t('tableHeader.tradePerson'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      key: 'productCount',
      title: i18n.t('tableHeader.tradeProd'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      key: 'subscribe',
      title: i18n.t('tableHeader.subscription'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      key: 'isExclusive',
      title: i18n.t('tableHeader.exclusive'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      title: i18n.t('operation'),
      // key: 'hide-opration',
      key: 'opration',
      width: 180,
      items: [
        {
          key: 'top',
          showName: {
            key: 'pinnedStatus',
            value: [1 , -1],
            name: [$i18.language('取消置顶'), $i18.language('置顶')]
          },
        },
        {
          name: i18n.t('tableHeader.viewDetails'),
          key: 'detail',
          icon: 'detail'
        },
        {
          name: i18n.t('tableHeader.yisou'),
          key: 'souUrl',
          icon: 'souUrl'
        },
        {
          name: i18n.t('tableHeader.modifyLabel'),
          key: 'label',
          icon: 'label',
          fold: true,
        },
        {
          name: i18n.t('tableHeader.downloadEnterprise'),
          key: 'download-company',
          icon: 'download-company',
          fold: true,
          showKey: {
            key: 'type',
            value: [7,3,4], //7.商业数据 3.4//企业数据
            isShowType:['businessDownload','companyDownload','companyDownload']
          }
        },
        {
          name: i18n.t('tableHeader.cancelAttention'),
          key: 'cancel-collect',
          icon: 'cancel-collect',
          fold: true,
        }
      ]
    }
  ],
  dashboardSmartBusiness: [
    {
      key: 'name',
      title: i18n.t('tableHeader.listName'),
      align: 'left',
      headerAlign: 'left',
      width: 150,
      type: 'customerlized'
    },
    {
      key: 'lastUpdateDate',
      title: i18n.t('tableHeader.updataTime'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'type',
      title: i18n.t('tableHeader.type'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized',
      width: 90
    },
    {
      key: 'buyerCount',
      title: i18n.t('tableHeader.numberOfBuyers'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      key: 'supplierCount',
      title: i18n.t('tableHeader.numberOfSuppliers'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      key: 'subscribe',
      title: i18n.t('tableHeader.subscription'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    },
    {
      title: i18n.t('operation'),
      // key: 'hide-opration',
      key:'opration',
      width:150,
      // type: 'customerlized',
      items: [
        {
          name: i18n.t('tableHeader.viewList'),
          key: 'detail',
          icon: 'detail'
        },
        {
          name: i18n.t('tableHeader.downloadListEnterprise'),
          key: 'download-company',
          icon: 'download-company',
          showKey:{
            key:'searchType',
            value:[1,3], //3.商业数据 1.特易搜搜
            isShowType:['companyDownload','businessDownload']
          }
        },
        {
          name: i18n.t('tableHeader.delete'),
          key: 'delete',
          icon: 'delete',
          showKey:{
            key:'searchType',
            value:[1,3], //3.商业数据 1.特易搜搜
            isShowType:[]
          }
        }
      ]
    }
  ],
  newDashboardSmartBusiness: [
    {
      key: 'title',
      title: i18n.t('tableHeader.listName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      key: 'updateDate',
      title: $i18.language('更新时间'),
    },
    {
      key: 'type',
      title: i18n.t('type'),
      type: 'customerlized'
    },
    {
      key: 'buyerCount',
      title: i18n.t('tableHeader.buyNum'),
    },
    {
      key: 'supplierCount',
      title: i18n.t('tableHeader.suppNum'),
    },
    {
      key: 'subscribe',
      title: i18n.t('tableHeader.subscription'),
      type: 'customerlized'
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      width: 180,
      type: 'customerlized',
      items: [
        {
          key: 'top',
          showName: {
            key: 'top',
            value: [true, false],
            name: [$i18.language('取消置顶'), $i18.language('置顶')]
          },
        },
        {
          name: i18n.t('tableHeader.viewDetails'),
          key: 'detail',
          icon: 'detail'
        },
        {
          name: i18n.t('tableHeader.downloadListEnterprise'),
          key: 'download',
          icon: 'download',
          // fold: true,
          showKey:{
            key:'type',
            value:[1, 2],
            isShowType:['companyDownload','companyDownload']
          }
        },
        {
          name: i18n.t('tableHeader.delete'),
          key: 'delete',
          icon: 'delete',
          showKey: {
            key: 'IsShowDelete',
            value: [true], //4.AI智能推荐
          }
        }
      ]
    }
  ],
  dashboardCompanyLogs: [
    {
      key: 'filename',
      title: i18n.t('tableHeader.exportFile'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      key: 'createDate',
      title: i18n.t('tableHeader.generationTime'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'type',
      title: i18n.t('type'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'companyCount',
      title: i18n.t('tableHeader.enterprisesIncluded'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'costPoint',
      title: i18n.t('tableHeader.actualDeduction'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'downloadCount',
      title: i18n.t('tableHeader.downloads'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      type: "customerlized",
      fixed: "right",
      items: [
        {
          name: i18n.t('tableHeader.downloadNew'),
          key: 'redownload',
          icon: 'redownload'
        },
        {
          name: i18n.t('tableHeader.delete'),
          key: 'delete',
          icon: 'delete',
        }
        // {
        //   name: i18n.t('delete'),
        //   key: 'delete',
        //   icon: 'delete'
        // }
      ],
      isShowType:'companyDownload'
    }
  ],
  dashboardTradeDataLogs: [
    {
      key: 'filename',
      title: i18n.t('tableHeader.exportFile'),
      align: 'left',
      headerAlign: 'left',
      width: 150,
      type: 'customerlized'
    },
    {
      key: 'createDate',
      title: i18n.t('tableHeader.generationTime'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'tradeDataCount',
      title: i18n.t('tableHeader.tradeNum'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'costPoint',
      title: i18n.t('tableHeader.actualDeduction'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'downloadCount',
      title: i18n.t('tableHeader.downloads'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      type: "customerlized",
      width: 130,
      fixed: "right",
      items: [
        {
          name: i18n.t('tableHeader.downloadNew'),
          key: 'redownload',
          icon: 'redownload'
        },
        {
          name: i18n.t('tableHeader.delete'),
          key: 'delete',
          icon: 'delete',
        }
        // {
        //   name: i18n.t('delete'),
        //   key: 'delete',
        //   icon: 'delete'
        // }
      ],
      isShowType:'tradeDownload'
    }
  ],
  //商业数据表头
  businessTableHeader: [
    {
      key: 'name',
      title: $i18.language('公司名称'),
      align: 'left',
      headerAlign: 'left',
      width: 200,
      type: 'customerlized',
      fixed: true
    },
    {
      key: 'companyTypeName',
      title: $i18.language('公司类型'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'country',
      title: $i18.language('国家'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'locationLocality',
      title: $i18.language('公司城市'),
      align: 'center',
      headerAlign: 'center',
      // type: 'customerlized'
    },
    {
      key: 'locationAddress1',
      title: $i18.language('公司地址'),
      align: 'center',
      headerAlign: 'center',

    },
    {
      key: 'locationPostalCode',
      title: $i18.language('邮编'),
      align: 'center',
      headerAlign: 'center',

    },
    {
      key: 'phones',
      title: $i18.language('电话'),
      align: 'center',
      headerAlign: 'center',

    },
    {
      key: 'website',
      title: $i18.language('网址'),
      align: 'center',
      headerAlign: 'center',
    },
    {
      key: 'companyIndustry',
      title: $i18.language('主要行业'),
      align: 'center',
      headerAlign: 'center',
    },
    // {
    //   key: 'description',
    //   title: '公司描述',
    //   align: 'center',
    //   headerAlign: 'center',
    // },
  ],
  //趋势分析中国专属 月度分析表头
  monthAnalysisDataTableHeader:[
    { label: $i18.language('日期'),
      prop: 'name',
      sortable:false,
      align: 'left',
      // headerAlign: 'left'
      },
    {
      label:i18n.t('amount'),
      sortable:false,
      rowSpan:[
            {
                label:$i18.language('金额(美元)'),
                prop: 'amountStr',
                sortable:'custom',
                align: 'right',
                // headerAlign: 'right'
            },
            {
                label: $i18.language('同比'),
                prop: 'y2yStr',
                sortable:'custom',
                align: 'right',
            },
            {
                label: $i18.language('环比'),
                prop: 'm2mStr',
                sortable:'custom',
                align: 'right',
            }
      ]
    },
    {
      label:i18n.t('tableHeader.numOneUnit'),
       sortable:false,
      rowSpan:[
            {
                label:$i18.language('金额(美元)'),
                prop: 'firstUnitCountStr',
                sortable:'custom',
                align: 'right',
            },
            {
                label: $i18.language('同比'),
                prop: 'firstUnitY2yStr',
                sortable:'custom',
                align: 'right',
            },
            {
                label: $i18.language('环比'),
                prop: 'firstUnitM2mStr',
                sortable:'custom',
                align: 'right',
            }
      ]
    },
    {
      label:i18n.t('tableHeader.numTwoUnit'),
       sortable:false,
      rowSpan:[
            {
                label: $i18.language('金额(美元)'),
                prop: 'secondUnitCountStr',
                sortable:'custom',
                align: 'right',
            },
            {       
                label: $i18.language('同比'),
                prop: 'secondUnitY2yStr',
                sortable:'custom',
                align: 'right',
            },
            {
                label: $i18.language('环比'),
                prop: 'secondUnitM2mStr',
                sortable:'custom',
                align: 'right',
            }  
      ]
    }
  ],
  // 趋势分析市场维度，表格视图
  marketTableHeader: [
    { 
      title: i18n.t('tableHeader.timeSlot'),
      align: 'left',
      key: 'time',
      sort: "custom",
    },
    { 
      title: i18n.t('trendAnalysis.Importexport'),
      align: 'left',
      key: 'ieName',
      isShowFilter: true,
      input: "radio"
    },
    { 
      title: i18n.t('tableHeader.tradePerson'),
      align: 'left',
      key: 'partner',
      isShowFilter: true,
      isShowSort: true,
      input: ""
    },
    { 
      title: i18n.t('hsCode'),
      align: 'left',
      key: 'hsCode',
      isShowFilter: true,
      isShowSort: true,
      input: "multTagText",
    },
    { 
      title: $i18.language('HS编码描述'),
      align: 'left',
      key: 'hsCodeProc',
    },
    { 
      title: $i18.language('金额（币种）'),
      key: 'amount',
      sort: "custom",
      align: 'right',
    },
    { 
      title: $i18.language('计量'),
      key: 'quantity',
      sort: "custom",
      align: 'right',
    },
    // { 
    //   title: $i18.language('计量单位'),
    //   key: 'name4',
    // },
    { 
      title: $i18.language('计算均价'),
      key: 'avgPrice',
      // sort: true
    },
  ],
  trendHsAmountRank: [
    { 
      title: $i18.language('HS编码描述'),
      key: 'title',
      align: 'left',
    },
    { 
      title: i18n.t('amount'),
      key: 'val',
      align: 'right',
    },
    { 
      title: $i18.language('占比'),
      key: 'ratio',
      align: 'right',
    },
  ],
  trendHsRank: [
    { 
      title: $i18.language('HS编码描述'),
      key: 'title',
      align: 'left',
    },
    { 
      title: $i18.language('计量'),
      key: 'val',
      align: 'right',
    },
    { 
      title: $i18.language('占比'),
      key: 'ratio',
      align: 'right',
    },
  ],
  trendPartnerAmount: [
    { 
      title: $i18.language('贸易伙伴排名'),
      key: 'title',
      align: 'left',
    },
    { 
      title: i18n.t('amount'),
      key: 'val',
      align: 'right',
    },
    { 
      title: $i18.language('占比'),
      key: 'ratio',
      align: 'right',
    },
  ],
  trendPartner: [
    { 
      title: $i18.language('贸易伙伴排名'),
      key: 'title',
      align: 'left',
    },
    { 
      title: $i18.language('计量'),
      key: 'val',
      align: 'right',
    },
    { 
      title: $i18.language('占比'),
      key: 'ratio',
      align: 'right',
    },
  ],
  cantonFair: [
    { 
      title: $i18.language('公司名称'),
      key: 'companyName',
      align: 'left',
      headerAlign: 'left',
      width: 180,
    },
    { 
      title: $i18.language('国家'),
      key: 'companyCountry',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('行业'),
      key: 'companyIndustry',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('产品'),
      key: 'purchaseProduct',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('联系人'),
      key: 'contacts',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('电话'),
      key: 'tel',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('传真'),
      key: 'fax',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('地址'),
      key: 'address',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('邮编'),
      key: 'zip',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('邮箱'),
      key: 'email',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('网址'),
      key: 'website',
      align: 'left',
      headerAlign: 'left',
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      width: 130,
      type: "customerlized",
      notTooltip: true,
      fixed: "right"
    }
  ],
  dashboardTradeCollect: [
    {
      key: 'sourceName',
      title: i18n.t('tableHeader.dataSource'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      key: 'buyer',
      title: $i18.language('采购商/供应商'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      key: 'productDesc',
      title: i18n.t('tradeData.tradeResult.productDescription'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
    },
    {
      key: 'onlyKey',
      title: $i18.language('数据唯一识别编码'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      key: 'createDate',
      title: $i18.language('收藏日期'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 50,
    },
    {
      title: i18n.t('operation'),
      // key: 'hide-opration',
      key: 'opration',
      items: [
        {
          key: 'top',
          showName: {
            key: 'pinnedStatus',
            value: [1 , -1],
            name: [$i18.language('取消置顶'), $i18.language('置顶')]
          },
        },
        {
          name: i18n.t('look'),
          key: 'detail',
          icon: 'detail'
        },
        {
          name: $i18.language('备注'),
          key: 'remark',
          icon: 'remark'
        },
        {
          name: $i18.language('取消收藏'),
          key: 'uncollection',
          icon: 'delete',
        }
      ]
    }
  ],
  creditColumns: [
    { 
      title: $i18.language('公司名称'),
      key: 'companyName',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('国家'),
      key: 'countryName',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('省份'),
      key: 'provinceName',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('行业'),
      key: 'industryName',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('调取时间'),
      key: 'time',
      align: 'left',
      headerAlign: 'left',
    },
    {
      title: $i18.language('状态'),
      key: 'status',
      type: "customerlized",
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      type: "customerlized",
      notTooltip: true,
      fixed: "right"
    }
  ],
  creditResultColumns: [
    { 
      title: $i18.language('公司名称'),
      key: 'companyName',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('国家'),
      key: 'countryName',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('省份'),
      key: 'provinceName',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('开业时间'),
      key: 'openDate',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('注册状态'),
      key: 'registrationStatus',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('完整度评分'),
      key: 'completeScore',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('更新时间'),
      key: 'updateDate',
      align: 'left',
      headerAlign: 'left',
    },
    { 
      title: $i18.language('公司类型'),
      key: 'companyClass',
      align: 'left',
      headerAlign: 'left',
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      type: "customerlized",
      notTooltip: true,
      fixed: "right"
    }
  ],
  trendChinaHsRank: [
    { 
      title: $i18.language('HS编码'),
      key: 'hsCode',
      align: 'left',
      width: '70'
    },
    { 
      title: $i18.language('HS编码描述'),
      key: 'hsCodeDesc',
      align: 'left',
      width: '160'
    },
    { 
      title: $i18.language('总额'),
      key: 'amount',
      align: 'right',
      width: '130'
    },
    { 
      title: $i18.language('占比'),
      key: 'ratio',
      align: 'right',
      width: '66'
    },
    { 
      title: $i18.language('同比增长率'),
      key: 'increaseRatio',
      align: 'right',
      // width: '56'
    },
  ],
  trendChinaPartner: [
    { 
      title: $i18.language('国家/地区'),
      key: 'country',
      align: 'left',
      // width: '60',
    },
    { 
      title: $i18.language('总额'),
      key: 'amount',
      align: 'right',
      width: '140'
    },
    { 
      title: $i18.language('占比'),
      key: 'ratio',
      align: 'right',
      // width: '56',
    },
    { 
      title: $i18.language('同比增长率'),
      key: 'increaseRatio',
      align: 'right',
      // width: '80',
    },
  ],
  // 标签管理
  collectLabels: [
    {
      title: i18n.t('tableHeader.labelName'),
      key: 'name',
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      items: [
        {
          name: i18n.t('tableHeader.modifyLabel'),
          key: 'edit',
          icon: 'edit'
        },
        {
          name: i18n.t('delete'),
          key: 'delete',
          icon: 'delete'
        }
      ]
    }
  ],
// 商机列表卡片
  dashboardSmartBusinessCard:[
    {
      key: 'title',
      title: i18n.t('tableHeader.listName'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
    },
    {
      key: 'type',
      title: i18n.t('tableHeader.type'),
      type: 'customerlized',
    },
    {
      key: 'updateDate',
      title: $i18.language('更新时间'),
    },
  ],
// 收藏提单卡片展示列表
  dashboardTradeCollectCard:[
    {
      key: 'sourceName',
      title: i18n.t('tableHeader.dataSource'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      key: 'buyer',
      title: $i18.language('采购商/供应商'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      key: 'productDesc',
      title: i18n.t('tradeData.tradeResult.productDescription'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
    },
  ],
  dashboardCollectCompanyCard: [
    {
      key: 'companyName',
      title: i18n.t('tableHeader.enterpriseName'),
      align: 'left',
      headerAlign: 'left',
      width: 180,
      type: 'customerlized'
    },
    {
      key: 'lastTradeDate',
      title: i18n.t('tableHeader.newTradetime'),
      align: 'center',
      headerAlign: 'center'
    },
    {
      key: 'tradeCount',
      title: i18n.t('tableHeader.tradeNumT'),
      align: 'center',
      headerAlign: 'center',
      type: 'customerlized'
    }
  ],
  aiCompanyTable:[
    {
      key: 'name',
      title: $i18.language('公司名称'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized'
    },
    {
      key: 'countryName',
      title: $i18.language('国家/地区'),
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'tradeCount',
      title: $i18.language('交易数'),
      align: 'left',
      headerAlign: 'left',
      width: 50,
    },
  ],
  aiTradeCountryTable:[
    {
      key: 'name',
      title: $i18.language('国家/地区'),
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'amount',
      title: $i18.language('金额(美元)'),
      align: 'left',
      headerAlign: 'left',
    },
  ],
  aiTradeData:[
    {
      key: 'dataSource',
      title: i18n.t('tableHeader.dataSource'),
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'tradeDate',
      title: i18n.t('tableHeader.newTradetime'),
      width: localStorage.getItem("language")=='en'?'120':'80',
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'supplierName',
      title: $i18.language('供应商名称'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 120
    },
    {
      key: 'buyerName',
      title: $i18.language('采购商名称'),
      align: 'left',
      headerAlign: 'left',
      type: 'customerlized',
      width: 120  
    },
    {
      key: 'hsCode',
      title: $i18.language('HS编码'),
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'productDesc',
      title: i18n.t('tradeData.tradeResult.productDescription'),
      type: 'customerlized',
      customerHeader: true,
      notTooltip: true,
      align: 'left',
      headerAlign: 'left',
    },

  ],
  dashboardForexToolCard: [
    {
      key: 'title',
      title: $i18.language('货币'),
      align: 'left',
      headerAlign: 'left',
      width: 80
    },
    {
      key: 'buy',
      title: $i18.language('现汇买入价'),
      type: 'customerlized',
      headerAlign: 'right',
      align: 'right'
    },
    {
      key: 'sell',
      title:$i18.language('卖出价'),
      align: 'right',
      headerAlign: 'right',
      type: 'customerlized'
    }
  ],
  dashboardGlobalTimeCard: [
    {
      key: 'TimeZone',
      title: $i18.language('时区'),
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'localtime',
      title:$i18.language('当地时间'),
      align: 'right',
      width: 70,
      headerAlign: 'right',
    }
  ],
  dashboardCommonSearchProduct: [
    {
      key: 'name',
      title: $i18.language('常用产品关键词'),
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'value',
      title:$i18.language('次数'),
    },
    {
      key: 'maxDate',
      title: $i18.language('最新查询日期')
    }
  ],
  dashboardCommonSearchHscode: [
    {
      key: 'name',
      title: $i18.language('HS编码'),
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'value',
      title:$i18.language('次数'),
    },
    {
      key: 'maxDate',
      title: $i18.language('最新查询日期')
    }
  ],
  dashboardCommonSearchMarket: [
    {
      key: 'country',
      title: $i18.language('常用搜索市场'),
      align: 'left',
      headerAlign: 'left',
    },
    {
      key: 'count',
      title:$i18.language('次数'),
    },
    {
      key: 'maxDate',
      title: $i18.language('最新查询日期')
    }
  ],
  dashboardVideoToolCard: [
    {
      key: 'title',
      align: 'left',
      headerAlign: 'left',
    },
    {
      title: i18n.t('operation'),
      key: 'opration',
      width: 20,
      type: "customerlized",
    }
  ]
}
